import { BaseNode } from '../Node/index';

/**
* 图层节点
*/
class Layer {
  constructor(props) {
    this.mapId = props.mapId;
    this.stateNode = new window.Konva.Layer({});
    this.groups = new Map(); // 同一zindex的将存入一个group 并对group直接进行分组布置层级
    this.zIndexs = [];
    this.stage = props.stage;
    this.index = props.index;
    this.init(props);
  }

  // 增加节点
  add(node) {        
    if (!node instanceof BaseNode) return;

    node.parent = this;

    const { stateNode } = node;

    const zIndex = node.renderData.zIndex || 0;

    if (!Number.isInteger(zIndex)) throw new Error('传递正确的zIndex 或不传默认0');

    const group = this.groups.get(zIndex);

    // 同一zindex的将存入一个group 并对group直接进行分组
    if (group) {
      group.add(stateNode);
    } else {
      // throw new Error('z-index控制在1-10以内');
      const insertGroup = new window.Konva.Group();

      this.groups.set(zIndex, insertGroup)
      this.stateNode.add(insertGroup);

      insertGroup.add(stateNode);

      const renderZIndex = this.zIndexs.findIndex(index => zIndex < index);

      insertGroup.zIndex(renderZIndex === -1 ? this.zIndexs.length : renderZIndex);

      this.zIndexs.push(zIndex);
      this.zIndexs.sort((a, b) => a - b);
    }
  }

  // 渲染图层
  render = () => {
    // console.log(`图层id 【 ${ this.mapId } 】 渲染`);

    this.stateNode.draw();
  }
}

export default Layer;